import React from 'react'

function GroupStatus({ status = '' }) {
    return (
        <div className='d-flex gap-1 align-items-center'>
            <div className={`group-status ${STATUS_LABELS[status]}`} />
            <div className="frame-wrapper">
                <div className="text9" title={status}>{STATUS_LABELS[status]}</div>
            </div>
        </div>
    )
}

export default GroupStatus

const STATUS_LABELS = {
    1: 'Pending',
    2: 'Approved',
    3: 'Rejected',
    4: 'Cancelled'
}